{
  "post-office.rovo-chat-button.main-heading.dismiss": [
    {
      "type": 0,
      "value": "Dismiss"
    }
  ],
  "post-office.rovo-chat-button.onboarding-heading": [
    {
      "type": 0,
      "value": "Chat with Rovo AI"
    }
  ],
  "post-office.rovo-chat-button.onboarding-input-placeholder-1": [
    {
      "type": 0,
      "value": "Pick a conversation starter or ask Rovo anything"
    }
  ],
  "post-office.rovo-chat-button.onboarding-input-placeholder-2": [
    {
      "type": 0,
      "value": "Write a prompt"
    }
  ],
  "post-office.rovo-chat-button.send-prompt": [
    {
      "type": 0,
      "value": "Send prompt"
    }
  ],
  "post-office.rovo-chat-recommended-spaces-spotlight.main-heading.dismiss": [
    {
      "type": 0,
      "value": "Dismiss"
    }
  ],
  "post-office.rovo-chat-spaces-spotlight.main-heading.dismiss": [
    {
      "type": 0,
      "value": "Dismiss"
    }
  ],
  "post-office.rovo-chat.3p-connector-nudge.connect-button": [
    {
      "type": 0,
      "value": "Connect "
    },
    {
      "type": 1,
      "value": "appName"
    }
  ],
  "post-office.rovo-chat.3p-connector-nudge.dismiss-button": [
    {
      "type": 0,
      "value": "Dismiss"
    }
  ],
  "post-office.rovo-chat.3p-connector-nudge.heading": [
    {
      "type": 0,
      "value": "Your admin has added "
    },
    {
      "type": 1,
      "value": "appName"
    }
  ],
  "post-office.rovo-chat.3p-connector-nudge.logo-alt": [
    {
      "type": 1,
      "value": "appName"
    },
    {
      "type": 0,
      "value": " logo"
    }
  ],
  "post-office.rovo-chat.3p-connector-nudge.subtitle": [
    {
      "type": 0,
      "value": "Connect your account to see more results"
    }
  ],
  "post-office.rovo-chat.long-running-task-fullpage-banner.body": [
    {
      "type": 0,
      "value": "Max takes on complex, multi-step work and comes back with a finished result."
    }
  ],
  "post-office.rovo-chat.long-running-task-fullpage-banner.cta-button": [
    {
      "type": 0,
      "value": "Get a team summary"
    }
  ],
  "post-office.rovo-chat.long-running-task-fullpage-banner.dismiss-button": [
    {
      "type": 0,
      "value": "Dismiss"
    }
  ],
  "post-office.rovo-chat.long-running-task-fullpage-banner.headline": [
    {
      "type": 0,
      "value": "Meet Max. It handles everything."
    }
  ],
  "post-office.rovo-chat.long-running-task-fullpage-banner.max-label": [
    {
      "type": 0,
      "value": "Max"
    }
  ],
  "post-office.rovo-chat.long-running-task-fullpage-banner.primary-task-meta": [
    {
      "type": 0,
      "value": "Awaiting user response"
    }
  ],
  "post-office.rovo-chat.long-running-task-fullpage-banner.primary-task-meta-timestamp": [
    {
      "type": 0,
      "value": "1 minute ago"
    }
  ],
  "post-office.rovo-chat.long-running-task-fullpage-banner.primary-task-title": [
    {
      "type": 0,
      "value": "Implement new authentication system"
    }
  ],
  "post-office.rovo-chat.long-running-task-fullpage-banner.secondary-task-meta": [
    {
      "type": 0,
      "value": "Just now"
    }
  ],
  "post-office.rovo-chat.long-running-task-fullpage-banner.secondary-task-title": [
    {
      "type": 0,
      "value": "New Policy Presentation"
    }
  ],
  "post-office.rovo-chat.long-running-task-spotlight.body": [
    {
      "type": 0,
      "value": "Max takes on complex, multi-step work and comes back with a finished result."
    }
  ],
  "post-office.rovo-chat.long-running-task-spotlight.headline": [
    {
      "type": 0,
      "value": "Say hi to Max"
    }
  ],
  "post-office.rovo-chat.long-running-task-spotlight.side-panel-banner.body": [
    {
      "type": 0,
      "value": "Max takes on complex, multi-step work for you."
    }
  ],
  "post-office.rovo-chat.long-running-task-spotlight.side-panel-banner.dismiss-button": [
    {
      "type": 0,
      "value": "Dismiss"
    }
  ],
  "post-office.rovo-chat.long-running-task-spotlight.side-panel-banner.headline": [
    {
      "type": 0,
      "value": "Meet Max. It handles everything."
    }
  ],
  "post-office.rovo-chat.long-running-task-spotlight.side-panel-banner.try-max-button": [
    {
      "type": 0,
      "value": "Try Max"
    }
  ],
  "post-office.rovo-chat.memory-settings-onboarding-spotlight.action": [
    {
      "type": 0,
      "value": "See how"
    }
  ],
  "post-office.rovo-chat.memory-settings-onboarding-spotlight.body": [
    {
      "type": 0,
      "value": "Rovo now remembers facts and details from your chats to make responses more personalized and helpful"
    }
  ],
  "post-office.rovo-chat.memory-settings-onboarding-spotlight.headline": [
    {
      "type": 0,
      "value": "A more personalized Rovo"
    }
  ],
  "post-office.rovo-chat.web-search-preference-spotlight.body": [
    {
      "type": 0,
      "value": "Web search is now on by default. You can turn it off anytime."
    }
  ],
  "post-office.rovo-chat.web-search-preference-spotlight.headline": [
    {
      "type": 0,
      "value": "Web search is on"
    }
  ],
  "post-office.rovo-chat.web-search-spotlight.body": [
    {
      "type": 0,
      "value": "We're running an experiment to improve Rovo. For some users, web search is now on by default—you can turn it off any time."
    }
  ],
  "post-office.rovo-chat.web-search-spotlight.dismiss": [
    {
      "type": 0,
      "value": "Turn off default web search"
    }
  ],
  "post-office.rovo-chat.web-search-spotlight.done": [
    {
      "type": 0,
      "value": "Done"
    }
  ],
  "post-office.rovo-chat.web-search-spotlight.headline": [
    {
      "type": 0,
      "value": "Web search is now on by default"
    }
  ],
  "post-office.rovo-chat.web-search-spotlight.manage-defaults": [
    {
      "type": 0,
      "value": "Manage my defaults"
    }
  ],
  "rovo-chat.inline-memory-saved-message.description.no-translate": [
    {
      "type": 0,
      "value": "This is a Post Office Test Message"
    }
  ],
  "rovo-chat.inline-memory-saved-message.title.no-translate": [
    {
      "type": 0,
      "value": "This is a Post Office Test Message"
    }
  ],
  "rovo-chat.rovo-chat-scheduled-chat-recurring-chat-complete.message-template.notification-drawer.message": [
    {
      "type": 0,
      "value": "Rovo has completed your scheduled query"
    }
  ],
  "rovo-chat.rovo-chat-task-awaiting-user.message-template.notification-drawer.message.no-translate": [
    {
      "type": 0,
      "value": "Rovo is awaiting your response"
    }
  ],
  "rovo-chat.rovo-chat-task-complete.message-template.notification-drawer.message": [
    {
      "type": 0,
      "value": "Rovo has completed your task"
    }
  ],
  "rovo-chat.rovo-chat-task-plan-generated.message-template.notification-drawer.message.no-translate": [
    {
      "type": 0,
      "value": "Rovo has generated your plan"
    }
  ]
}